/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { gnoment } from 'shared-ui/gnoment';
import * as types from '../constants';

export const createSimpleRule = (ruleName, permit, divisionId, value) => {
    return {
        permit_id: permit.id,
        division_id: divisionId,
        name: ruleName,
        operation: 'None',
        start_date: gnoment().utc().clone().subtract(365, 'days'),
        end_date: gnoment().utc().clone().add(365, 'days'),
        target: 'None',
        type: -1,
        value,
    };
};

export const transformPermit = (p) => {
    const originalPermit = p;
    if (!originalPermit) {
        return {};
    }

    // re-organize the rules so they're indexable by name
    let rules = {};
    originalPermit.rules.forEach((x) => {
        const { name, ...rule } = x;
        if (
            [
                'HighUseRegistrationStart',
                'HighUseRegistrationEnd',
                'LotteryResultsAvailable',
                'CancellationDeadline',
                'HighUseSeasonStart',
                'HighUseSeasonEnd',
                'SeasonStart',
                'SeasonEnd',
                'LotteryDeadlineToConfirm',
                'DisplayDate',
                'LotteryDisplayDate',
                'LotteryExecutionDate',
            ].find((y) => y === name)
        ) {
            rule.value *= types.EPOCH_MULTIPLIER;
        }
        rules = Object.assign(rules, { [name]: rule });
    });

    originalPermit.indexed_rules = rules;

    const permit = { ...originalPermit };
    if (permit.divisions) {
        Object.keys(permit.divisions).forEach((divisionId) => {
            permit.divisions[divisionId].isStartingPoint = true;
            permit.divisions[divisionId].childDivisions = [];

            // Remove inactive divisions
            if (!permit.divisions[divisionId].is_active) {
                delete permit.divisions[divisionId];
            }
        });
    }

    return permit;
};
